import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { meetingTypesArray } from '../../shared/meetingTypeToTranslationKey';
import printIcon from "../../assets/images/printer.svg";
import BookingMeetingList from '../BookingMeetingList/BookingMeetingList';
import { Icon } from '../Icon/Icon';
import PendingBookingsButton from '../PendingBookingsButton/PendingBookingsButton';
import { PermissionFlags } from '../PermissionFlags/PermissionFlags';
import PrimaryButton from '../PrimaryButton/PrimaryButton';
import PrintModal from '../PrintModal/PrintModal';
import SecondaryButton from '../SecondaryButton/SecondaryButton';
import SlideOver from '../SlideOver/SlideOver';

type Props = {
  onNewFn?: (value: any) => void,
  onOpenSalesFlow?: () => void,
}

const CalendarFooter = ({ onNewFn, onOpenSalesFlow }: Props) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const togglePrintModal = () => setIsModalOpen(prev => !prev);
  const [editOpen, setEditOpen] = useState<boolean>(false);

  return (
    <>
      <PrintModal 
        onClose={() => setIsModalOpen(false)}
        onPrint={() => null}
        isOpen={isModalOpen}
        meetingTypes={meetingTypesArray}
      />
      <div className="mt-4 flex space-x-2 flex-wrap">
        <PermissionFlags requiredFlags={['create-meetings'] || []}>
          <>
            <PrimaryButton text={t("calendar.new_meeting.button")!} fn={onNewFn} actionName="New Meeting"/>
            <PendingBookingsButton onOpenSlideOver={() => setEditOpen(true)} />
          </>
        </PermissionFlags>
        {onOpenSalesFlow && (
          <PermissionFlags requiredFlags={['create-meetings'] || []}>
            <PrimaryButton 
              text={t("calendar.new_sale.button")!}
              fn={onOpenSalesFlow} 
              actionName="New Sale"
            />
          </PermissionFlags>
        )}
        <PermissionFlags requiredFlags={['print-meetings'] || []}>
          <SecondaryButton compact text={t("calendar.print.button")!} fn={togglePrintModal} actionName="Print Meetings" icon={<Icon url={printIcon}></Icon>} iconPosition='left'/>
        </PermissionFlags>
      </div>
      <SlideOver
        isOpen={editOpen}
        setIsOpen={setEditOpen}
        title={t("booking.pending.title")!}
        isLoading={false}
      >
        <BookingMeetingList onClose={() => setEditOpen(false)} />
      </SlideOver>
    </>
  );
};

export default CalendarFooter;